import cn from 'classnames';
import T from 'prop-types';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import Img from '../../components/img/Img';
import useBreakpoint from '../../hooks/useBreakpoint';
import text from '../../text';
import { LayoutContext } from '../LayoutContext';
import FileManagerFallbackArrow from './FileManagerFallbackArrow';
export default function FileManagerFallbackOverlay(param) {
    var show = param.show;
    var sideNav = useSelector(function(state) {
        return {
            sideNav: state.layout.sideNav
        };
    }).sideNav;
    var isFallbackArrowVisibleForBreakpoint = useBreakpoint([
        'lg',
        'xl'
    ]);
    var startNewProjectRef = useContext(LayoutContext).startNewProjectRef;
    return /*#__PURE__*/ React.createElement("div", {
        id: "file-manager-fallback-overlay",
        className: cn('file-manager-fallback-overlay', show && 'show')
    }, /*#__PURE__*/ React.createElement(FileManagerFallbackArrow, {
        show: isFallbackArrowVisibleForBreakpoint && sideNav.isVisible && show,
        referenceElement: startNewProjectRef
    }), /*#__PURE__*/ React.createElement("div", {
        className: "content"
    }, /*#__PURE__*/ React.createElement(Img, {
        img: "file-manager-fallback-illustration",
        alt: text('startNewProject')
    }), /*#__PURE__*/ React.createElement("h3", null, text('startANewProject')), /*#__PURE__*/ React.createElement("p", null, text('fileManagerInstructions'))));
}
FileManagerFallbackOverlay.propTypes = {
    show: T.bool.isRequired
};
